/**
 * App.js Layout Start Here
 */
import React from 'react';
import {NotificationContainer} from 'react-notifications';
import {connect} from 'react-redux';
import {Redirect, Route, Switch} from 'react-router-dom';
import {compose} from 'redux';
import EmailVerification from '../components/EmailVerification/EmailVerification';
import {default as ExternalServiceCallback} from '../components/ExternalServiceCallback';
import FreshBooksCallback from '../components/IntegrationCallback/FreshBooksCallback';
import IntegrationCallback from '../components/IntegrationCallback/IntegrationCallback';
import LoginTroubleshooting from '../components/LoginTroubleshooting/LoginTroubleshooting';
import SendVerificationLetterForm from '../components/LoginTroubleshooting/SendVerificationLetterForm';
import ChangePassword from '../components/ResetPasswordComponents/ChangePassword';
import ForgotPassword from '../components/ResetPasswordComponents/ForgotPassword';
import ResetPasswordConfirm from '../components/ResetPasswordComponents/ResetPasswordConfirm';
import ThemeOptions from '../components/ThemeOptions/ThemeOptions';
import {
    accessTokenLocalStorageKey,
    externalServiceProviderFacebook,
    externalServiceProviderGoogle,
    facebookCallbackRouter,
    googleCallbackRoute,
    integrationNameACS,
    integrationNameQB,
    integrationNameXero,
} from '../constants';
import storage from '../fetchApi/storage';
import RctDefaultLayout from './DefaultLayout';
import AppSignIn from './Login/SignIn';
import AppSignUp from './Login/SignUp';
import ReactProviders from './ReactProviders';

const unauthorizedRoutes = () => [
    <Route path="/signin" key='signin' component={AppSignIn} />,
    <Route path="/signup" key='signup' component={AppSignUp} />,
    <Route
        path={`/${googleCallbackRoute}`}
        key='google'
        render={(routerProps) => (
            <ExternalServiceCallback {...routerProps} provider={externalServiceProviderGoogle} />
        )}
    />,
    <Route
        path={`/${facebookCallbackRouter}`}
        key='facebook'
        render={(routerProps) => (
            <ExternalServiceCallback {...routerProps} provider={externalServiceProviderFacebook} />
        )}
    />,
    <Route path='/forgotPassword' key='forgotPassword' component={ForgotPassword} />,
    <Route path='/changePassword' key='changePassword' component={ChangePassword} />,
    <Route path='/resetPasswordConfirm' key='resetPasswordConfirm' component={ResetPasswordConfirm} />,
    <Route path='/emailVerification' key='confirmEmail' component={EmailVerification} />,
    <Route path='/signInTroubleshooting' key='singInTroubleshooting' component={LoginTroubleshooting} />,
    <Route path='/sendVerificationLetter' key='sendVerificationLetter' component={SendVerificationLetterForm}/>,
    <Redirect to='/signin' key='signin_redirect' />,
];

const authorizedRoutes = () => [
    <Redirect exact path="/" to='/documents' key='default_redirect' />,
    <Route
        exact
        path='/accountingSuiteCb'
        render={(props) => (
            <IntegrationCallback
                {...props}
                provider={integrationNameACS}
            />
        )}
        key='ACS'
    />,
    <Route
        exact
        path='/xeroCallback'
        render={(props) => (
            <IntegrationCallback
                {...props}
                provider={integrationNameXero}
            />
        )}
        key='Xero'
    />,
    <Route
        exact
        path='/quickBooksCallback'
        render={(props) => (
            <IntegrationCallback
                {...props}
                provider={integrationNameQB}
            />
        )}
        key='QB'
    />,
    <Route
        exact
        path='/freshBooksCallback'
        render={(props) => (
            <FreshBooksCallback {...props} />
        )}
        key='FreshBooks'
    />,
    <Route exact path='/resetPasswordConfirm' key='resetPasswordConfirm' component={ResetPasswordConfirm} />,
    <Route exact path='/changePassword' key='changePassword' component={ChangePassword} />,
    <Route path="/" component={RctDefaultLayout} key='default' />,
];

const App = ({}) => {
    const isLoggedIn = storage.load(accessTokenLocalStorageKey);
    return (
        <ReactProviders>
            <NotificationContainer />
            <Switch>
                {!isLoggedIn && unauthorizedRoutes()}
                {isLoggedIn && authorizedRoutes()}
            </Switch>
            <ThemeOptions user={isLoggedIn} />
        </ReactProviders>
    );
};

const mapStateToProps = ({authUser}) => ({
    isLoggedIn: authUser.isLoggedIn
});

export default compose(connect(mapStateToProps, {}))(App);
